export enum BlockableEntityType {
    Customer = 'Customer',
    CustomerOrder = 'CustomerOrder',
    ProductionOrder = 'ProductionOrder',
}

export const BLOCKABLE_ENTITY_TYPES = Object.values(BlockableEntityType);

export enum BlockReasonType {
    SoftDelete = 'SoftDelete',
    CreditLimit = 'CreditLimit',
    IncompleteData = 'IncompleteData',
    Other = 'Other',
}

export const BLOCK_REASON_TYPES = Object.values(BlockReasonType);

/** Reasons available for user-created/updated blocks (excludes system-managed SoftDelete). */
export const SELECTABLE_BLOCK_REASON_TYPES = BLOCK_REASON_TYPES.filter(reason => reason !== BlockReasonType.SoftDelete);

export const BLOCK_DESCRIPTION_MAX_LENGTH = 2048;

/** Payload for POST /api/v1/block */
export interface IBlockRequestDto {
    entityType: BlockableEntityType;
    entityId: string;
    reason: BlockReasonType;
    description?: string | null;
}

export interface IEntityBlockRequest extends IBlockRequestDto {
    entityName: string;
}

export interface IEntityBlockFormData {
    entityType: BlockableEntityType;
    entityName: string;
    reason: BlockReasonType | null;
    description: string;
}

export interface IEntityBlockRecord {
    id: string;
    entityType: BlockableEntityType;
    entityId: string;
    reason: BlockReasonType;
    description?: string | null;
    version?: string | null;
    createdAt: string;
    createdBy: string;
}

export interface IEntityBlockListResponse {
    value: IEntityBlockRecord[];
}

export interface IEntityBlockUpdateRequest {
    id: string;
    entityType: BlockableEntityType;
    entityId: string;
    reason: BlockReasonType;
    description?: string | null;
}

export interface IEntityBlockUpdateDto {
    reason: BlockReasonType;
    description?: string | null;
}

export const ENTITY_BLOCK_STATUS_TRANSLATION_PREFIX: Record<BlockableEntityType, string> = {
    [BlockableEntityType.Customer]: 'enum_customer_status_',
    [BlockableEntityType.CustomerOrder]: 'enum_order_status_',
    [BlockableEntityType.ProductionOrder]: 'enum_production_order_status_',
};
